export default __webpack_public_path__ + "static/media/newcrcover.85cb98fa.png";